var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditTin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.8,17.7C3.3,18.2,3,18.9,3,19.6c0,0.7,0.3,1.4,0.8,1.9l0.8,0.9c7.2,6.9,24.6-10.6,17.9-17.8l-1-0.9C21,3.3,20.3,3,19.6,3 s-1.4,0.3-1.9,0.8c0,0-1.7,2.1-1.7,2.1c-0.5,0.5-0.8,1.2-0.7,1.9c0,0.7,0.3,1.4,0.8,1.9l1,1.3c-0.6,1.4-1.4,2.6-2.4,3.6 c-1,1-2.3,1.9-3.6,2.4l-1.3-1c-0.5-0.5-1.2-0.8-1.9-0.8c-0.7,0-1.4,0.3-1.9,0.7C5.9,16,3.8,17.6,3.8,17.7z M5,18.9 c0,0,2.1-1.6,2.1-1.6C7.3,17.1,7.5,17,7.8,17s0.5,0.1,0.7,0.3c0,0,1.8,1.4,1.8,1.4c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3,0,0.4,0 c1.8-0.7,3.4-1.7,4.7-3c1.3-1.3,2.4-2.9,3-4.7c0.1-0.1,0.1-0.3,0.1-0.5c0-0.2-0.1-0.3-0.2-0.4c0,0-1.4-1.8-1.4-1.8 C17.1,8.3,17,8.1,17,7.8s0.1-0.5,0.3-0.7c0,0,1.6-2.1,1.6-2.1c0.2-0.2,0.4-0.3,0.7-0.2c0.2,0,0.5,0.1,0.7,0.3l1,0.9 c4.9,5.9-10.2,20.2-15.4,15.3l-0.8-0.9c-0.2-0.2-0.3-0.4-0.3-0.7C4.7,19.4,4.8,19.1,5,18.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    x1: 3.5,
    y1: 6.4,
    x2: 12.5,
    y2: 6.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    x1: 3.5,
    y1: 9.6,
    x2: 12.5,
    y2: 9.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    x1: 6.9,
    y1: 3.3,
    x2: 5.8,
    y2: 12.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    x1: 10.2,
    y1: 3.3,
    x2: 9.1,
    y2: 12.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTin);
export default __webpack_public_path__ + "static/media/editTin.3c7603fdfdd2fa8f2be2eecb4d7672e7.svg";
export { ForwardRef as ReactComponent };